import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFiles,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import RequestsDetailsSectionInfo from '../sections/RequestsDetailsSectionInfo';
import RequestsDetailsSectionSecondaryInfo from '../sections/RequestsDetailsSectionSecondaryInfo';

export default function RequestsDetailsTab(props: DetailsPageContentProps) {
	const { sysSettings, t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<RequestsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="reqs_descriptionhtml"
							value={props.model.reqs_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="requests" uid={props.model.reqs_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<RequestsDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					{!props.isAdd && !!props.model.reqs_foldername && (
						<Grid size={12}>
							<DetailsSectionFiles
								icon={<Icon icon="attachment" />}
								title={t('DETAILS_ATTACHED_FILES_SECTION')}
								subheader={t('DETAILS_ATTACHED_FILES_SUBHEADER')}
								folderPath={`${sysSettings.docs_path}${props.model.reqs_foldername}`}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
